import { render, staticRenderFns } from "./educationComplete.vue?vue&type=template&id=0b6aa532"
import script from "./educationComplete.vue?vue&type=script&lang=js"
export * from "./educationComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6aa532')) {
      api.createRecord('0b6aa532', component.options)
    } else {
      api.reload('0b6aa532', component.options)
    }
    module.hot.accept("./educationComplete.vue?vue&type=template&id=0b6aa532", function () {
      api.rerender('0b6aa532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationComplete.vue"
export default component.exports